import React from "react"

import ProjectIconUI5 from "../../../../../../core/gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../../core/gd-components/icons/@const";

export default function newDocument_getMyTemplates() {
    const templates = _.chain(gd.session.templatesList.models)
        .filter(t=>t.companyId === gd.companyId && !t.isDeleted && t.isPage)
        .orderBy(t=>t.sortPosition)
        .value()

    const res: any = []

    res.push({
        typeId      : "empty",
        icon        : "ii5-task-list",
        title       : "Empty page",
        description : "Create and organize documents in a flexible hierarchy."
    });

    // res.push({
    //     typeId      : "empty-whiteboard", // Zavisimosti kakoy typeId delatsya raznie zaprosi pri sozdanii document
    //     icon        : "i5-whiteboard",
    //     title       : "Whiteboard",
    //     description : "Create a new collaborative Whiteboard for visual brainstorming and planning."
    // });

    templates.map(template=>{
        res.push({
            id              : template.id,
            typeId          : "template",
            icon            : template.iconClass,
            iconComponent   : <ProjectIconUI5 className="option-icon" size={ItemIconSize.SIZE_27} projectId={template.id} colorize={false}/>,
            title           : template.name,
            description     : template.description ? template.description : "No description"
        })
    })

    return res
}
